import React from "react";
import FloatingCard from "../../../ui/FloatingCard";
import FloatingButton from "../../../ui/FloatingButton";

const LiveMatchEventModal = ({
  show,
  eventData,
  setEventData,
  scoringTemplate,
  match,
  getEventTypes,
  onSubmit,
  onClose,
  connected,
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay-gaming">
      <FloatingCard variant="primary" size="large" className="modal-card">
        <div className="modal-content-gaming">
          <div className="modal-header-gaming">
            <h3>➕ Add Match Event</h3>
            <FloatingButton
              onClick={onClose}
              variant="danger"
              size="small"
              icon="×"
            >
              Close
            </FloatingButton>
          </div>

          <form onSubmit={onSubmit} className="event-form-gaming">
            <div className="form-grid-gaming">
              <div className="form-group-gaming">
                <label>👤 Participant:</label>
                <select
                  value={eventData.participant_id}
                  onChange={(e) =>
                    setEventData({
                      ...eventData,
                      participant_id: parseInt(e.target.value),
                    })
                  }
                  className="gaming-select"
                  required
                >
                  <option value="">Select Participant</option>
                  <option value={match.participant1Id}>
                    Participant {match.participant1Id}
                  </option>
                  <option value={match.participant2Id}>
                    Participant {match.participant2Id}
                  </option>
                </select>
              </div>

              <div className="form-group-gaming">
                <label>⚡ Event Type:</label>
                <select
                  value={eventData.event_type}
                  onChange={(e) =>
                    setEventData({
                      ...eventData,
                      event_type: e.target.value,
                    })
                  }
                  className="gaming-select"
                  required
                >
                  <option value="">Select Event Type</option>
                  {getEventTypes().map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.icon} {type.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group-gaming">
                <label>⏱️ Event Time (minutes):</label>
                <input
                  type="number"
                  value={eventData.event_time}
                  onChange={(e) =>
                    setEventData({
                      ...eventData,
                      event_time: parseInt(e.target.value) || 0,
                    })
                  }
                  className="gaming-input"
                  min="0"
                  required
                />
              </div>

              {scoringTemplate?.scoring_type === "points" &&
                eventData.event_type === "field_goal" && (
                  <div className="form-group-gaming">
                    <label className="checkbox-label-gaming">
                      <input
                        type="checkbox"
                        checked={eventData.event_data.isThreePointer || false}
                        onChange={(e) =>
                          setEventData({
                            ...eventData,
                            event_data: {
                              ...eventData.event_data,
                              isThreePointer: e.target.checked,
                            },
                          })
                        }
                      />
                      🏀 Three Pointer
                    </label>
                  </div>
                )}

              {scoringTemplate?.scoring_type === "runs_wickets" &&
                eventData.event_type === "runs" && (
                  <div className="form-group-gaming">
                    <label>🏏 Number of Runs:</label>
                    <input
                      type="number"
                      value={eventData.event_data.runs || 1}
                      onChange={(e) =>
                        setEventData({
                          ...eventData,
                          event_data: {
                            ...eventData.event_data,
                            runs: parseInt(e.target.value) || 1,
                          },
                        })
                      }
                      className="gaming-input"
                      min="1"
                      max="6"
                    />
                  </div>
                )}
            </div>

            <div className="form-actions-gaming">
              <FloatingButton
                type="button"
                onClick={onClose}
                variant="secondary"
                size="medium"
                icon="❌"
              >
                Cancel
              </FloatingButton>
              <FloatingButton
                type="submit"
                variant="success"
                size="medium"
                icon="➕"
                disabled={!connected}
              >
                Add Event
              </FloatingButton>
            </div>
          </form>
        </div>
      </FloatingCard>
    </div>
  );
};

export default LiveMatchEventModal;
